import { createApp } from 'vue';
// import { configureCompat } from 'vue'
import { createPinia } from 'pinia';

require('./bootstrap');
window.moment = require('moment')


import Auth from './auth'
window.Auth = Auth;

import 'core-js/stable'
import 'regenerator-runtime/runtime';
import 'intersection-observer';


import postError from './helpers/postError'

// window.basePath = process.env.MIX_APP_URL;

import HowToRow from './components/HowToRow';
import HowToVideo from './components/HowToVideo';
import BaseCollapse from './components/BaseCollapse'
import TaResources from './components/TaResources/TaResources';
import BuildTheSkills from './components/BuildTheSkills/BuildTheSkills'
import PrintDropdown from './components/PrintDropdown';
import PrintManual from './components/PrintManual';

import SectionCollapse from './components/TaResources/SectionCollapse';
import ActivityCollapse from './components/TaResources/ActivityCollapse';
import ProviderToolsSpotlight from './components/TaResources/ProviderToolsSpotlight';
import ConsultantToolsSpotlight from './components/TaResources/ConsultantToolsSpotlight';
import HelpfulHints from './components/TaResources/HelpfulHints';

if (document.getElementById('vue-app')) {
    const pinia = createPinia();
    const app = createApp({
    components: {
        TaResources
    }
  });
    
  app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
  app.use(pinia);
  app.mount('#vue-app');
}

// configureCompat({
//     MODE: 3,
//     // COMPONENT_V_MODEL: false,
//     INSTANCE_EVENT_EMITTER: false,
//     ATTR_FALSE_VALUE: false,
// })

require('./pages/modal_login.js')
require('./pages/registration_codes.js');
require('./pages/register.js');
require('./pages/consultants/connections.js');
require('./pages/consultants/consultant_dashboard.js');
require('./pages/consultants/program.js')
require('./pages/consultants/program_more_info.js')
require('./pages/tips_and_materials.js');
require('./pages/materials/favorite_tips_and_materials.js');
require('./pages/partners/users.js')
require('./pages/partner_register.js') // jquery
require('./pages/header_mobile_navigation_and_login.js') // jquery
require('./pages/homepage_what_is_our_focus.js') // jquery
require('./pages/modal_video.js') // jquery
require('./pages/contact_us.js') // vanilla w/ axios
require('./pages/program_register.js');
require('./pages/program_my_account.js')
require('./pages/participating_states.js')
require('./pages/survey.js')
require('./pages/self-assessments-dashboard')
require('./pages/self-assessments-intro')
require('./pages/programs/my_napsacc')
require('./pages/assessments/section_results_detail')
require('./pages/programs/dashboard')
require('./pages/search_public.js')
require('./pages/action_plan')
require('./pages/action_plans/create.js') // jquery
require('./pages/action_plans/start.js')
require('./pages/action_plans/dashboard.js')
require('./pages/action_plans/goal_selection.js')
require('./pages/programs/full_progress.js')
require('./pages/reports.js')
require('./pages/partners/consultant_detail.js')
require('./pages/public/self_assessment/consent.js')
require('./pages/help.js')

import { EmbedApi, PlayerState} from './components/trainings/embedapi.min.js';
window.EmbedApi = EmbedApi;
window.PlayerState = PlayerState;

require('./pages/trainings/dashboard.js');
require('./pages/trainings/ta-training-videos.js');
// require('./pages/trainings/provider-training-modals.js');
